import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'safety',
  templateUrl: './safety.component.html',
  styleUrls: ['./safety.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class SafetyComponent {

}
